import { graphql } from '@/graphql-setup'

export const TOGGLE_APPROVED_DRIVER_ACTIVITY_MUTATION = graphql(`
  mutation ToggleApprovedDriverActivitiesMutation(
    $user: ID!
    $datetimeStart: DateTime!
    $datetimeEnd: DateTime!
    $approve: Boolean!
  ) {
    toggleApprovedDriverActivity(
      user: $user
      datetimeStart: $datetimeStart
      datetimeEnd: $datetimeEnd
      approve: $approve
    ) {
      ok
    }
  }
`)

export const UPDATE_OR_CREATE_DRIVER_DIET_MUTATION = graphql(`
  mutation UpdateOrCreateDriverDiet($input: UpdateOrCreateDriverDietInput!) {
    updateOrCreateDriverDiet(input: $input) {
      ok
      diet {
        id
        date
        partOfDay
        comment
        salaryCode {
          id
          name
        }
        calendarItem {
          id
        }
      }
    }
  }
`)

export const UPDATE_OR_CREATE_SALARY_DAY_MUTATION = graphql(`
  mutation UpdateOrCreateSalaryDay($input: UpdateOrCreateSalaryDayInput!) {
    updateOrCreateSalaryDay(input: $input) {
      ok
      salaryDay {
        id
        date
        partOfDay
        salaryCode {
          id
          name
        }
      }
    }
  }
`)

export const CREATE_TACHO_DRIVER_FILE_MUTATION = graphql(`
  mutation CreateTachoDriverFile($input: CreateTachoDriverFileInput!) {
    createTachoDriverFile(input: $input) {
      tachoDriverFile {
        id
        fileName
        updatedAt
      }
    }
  }
`)

export const CREATE_TACHO_VEHICLE_FILE_MUTATION = graphql(`
  mutation CreateTachoVehicleFile($input: CreateTachoVehicleFileInput!) {
    createTachoVehicleFile(input: $input) {
      tachoVehicleFile {
        id
        fileName
        updatedAt
      }
    }
  }
`)

export const UPDATE_OR_CREATE_DRIVER_COMMENT_MUTATION = graphql(`
  mutation UpdateOrCreateDriverComment(
    $input: UpdateOrCreateDriverCommentInput!
  ) {
    updateOrCreateDriverComment(input: $input) {
      ok
      comment {
        id
        date
        comment
        user {
          id
          fullName
        }
      }
    }
  }
`)

export const TOGGLE_ACTIVITY_EXCLUDE_FROM_SALARY_CALCULATION_MUTATION = graphql(
  `
    mutation ToggleActivityExcludeFromSalaryCalculation(
      $activity: ID!
      $value: Boolean!
      $excludeBefore: DateTime
      $excludeAfter: DateTime
    ) {
      toggleActivityExcludeFromSalaryCalculation(
        activity: $activity
        value: $value
        excludeBefore: $excludeBefore
        excludeAfter: $excludeAfter
      ) {
        activity {
          id
          excludeFromSalaryCalculation
          excludeBefore
          excludeAfter
        }
      }
    }
  `
)
